import { render, staticRenderFns } from "./modal-cross-compile-error.vue?vue&type=template&id=9a8921f0&scoped=true&"
import script from "./modal-cross-compile-error.vue?vue&type=script&lang=js&"
export * from "./modal-cross-compile-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8921f0",
  null
  
)

export default component.exports